/**
 * Service Grid Animation Logic - Anti-Flicker & Batch Optimized
 */

document.addEventListener("DOMContentLoaded", () => {
	if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
		console.warn("GSAP/ScrollTrigger not found. Service Grid animation skipped.");
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const grids = document.querySelectorAll('.osmerova-service-grid[data-gsap="service-grid"]');

	grids.forEach((grid) => {
		let ctx = gsap.context(() => {

			// 1. Heading Animation
			const heading = grid.querySelector('.osmerova-service-grid__inner > h2, .osmerova-service-grid__inner > h3');
			if (heading) {
				// Použitie autoAlpha rieši FOUC lepšie ako opacity
				gsap.set(heading, { y: 30, autoAlpha: 0 });

				gsap.to(heading, {
					scrollTrigger: {
						trigger: heading,
						start: "top 85%",
					},
					y: 0,
					autoAlpha: 1,
					duration: 0.8,
					ease: "power2.out",
					clearProps: "all"
				});
			}

			// 2. Cards Animation (Batch s ochranou proti prebliknutiu)
			const cards = gsap.utils.toArray(grid.querySelectorAll('.wp-block-osmerova-service-card'));
			if (cards.length > 0) {
				// Kľúčový krok: Okamžité skrytie cez autoAlpha (zamedzuje mobilnému preblikávaniu)
				gsap.set(cards, { y: 50, autoAlpha: 0 });

				ScrollTrigger.batch(cards, {
					interval: 0.1,
					batchMax: 3,
					onEnter: batch => gsap.to(batch, {
						y: 0,
						autoAlpha: 1,
						duration: 0.8,
						stagger: 0.15,
						ease: "power2.out",
						overwrite: true,
						clearProps: "all" // Totálne vyčistí DOM po skončení animácie
					}),
					start: "top 85%",
				});
			}

			// 3. Button Animation
			const buttons = grid.querySelector('.wp-block-buttons');
			if (buttons) {
				gsap.set(buttons, { y: 30, autoAlpha: 0 });

				gsap.to(buttons, {
					scrollTrigger: {
						trigger: buttons,
						start: "top 90%",
					},
					y: 0,
					autoAlpha: 1,
					duration: 0.8,
					ease: "power2.out",
					clearProps: "all"
				});
			}

		}, grid);
	});
});
